export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': 'México',
  '2': 'América Central e Caraíbas',
  '3': 'A China e a Grande China',
  '4': 'Singapura',
  '5': 'Turquia',
  '6': 'Filipinas',
  '7': 'Equador',
  '8': 'izzi',
  '9': 'Roménia',
  '16': 'Itbm',
  '17': 'One Survey',
}


export const sectores = {
  "1":{
     "NOMBRE":"2.0 Aeroespacial",
     "SUBSECTORES":{
        "1":"2.1 Aeroespacial // Outros / Não se aplica"
     }
  },
  "2":{
     "NOMBRE":"4.0 Agricultura",
     "SUBSECTORES":{
        "1":"4.1 Agricultura // Outros / Não se aplica "
     }
  },
  "3":{
     "NOMBRE":"5.0 Biotecnologia e Produtos Farmacêuticos",
     "SUBSECTORES":{
        "1":"5.1 Biotecnologia e Farmacêutica // Biotecnologia",
        "2":"5.2 Biotecnologia e Farmacêutico // Farmacêutico",
        "3":"5.3 Biotecnologia e Farmacêutica // Outros"
     }
  },
  "4":{
     "NOMBRE":"6.0 Construção",
     "SUBSECTORES":{
        "1":"(ANTIGO) Construção // Contratação",
        "2":"(OLD) Construção // Infraestrutura",
        "3":"6.1 Construção // Outro / Não se aplica"
     }
  },
  "5":{
     "NOMBRE":"12,0 Cuidados de saúde",
     "SUBSECTORES":{
        "1":"(OLD) Cuidados de saúde // Serviços de cuidados residenciais",
        "2":"12.1 Saúde // Hospital",
        "3":"12.2 Saúde // Venda ou distribuição de suprimentos médicos",
        "4":"12.3 Cuidados de saúde // Especialidade",
        "5":"(Antigo) Serviços de Envelhecimento // Home Care",
        "6":"(ANTIGO) Serviços de Idosos // Alojamento e cuidados para idosos",
        "7":"(OLD) Assistência médica // Outros serviços especializados",
        "8":"12.4 Cuidados de Saúde // Serviços",
        "9":"12.5 Cuidados de saúde // Outro",
     }
  },
  "6":{
     "NOMBRE":"7.0 Educação e treinamento",
     "SUBSECTORES":{
        "1":"7.1 Educação e treinamento // Outro / Não se aplica"
     }
  },
  "7":{
     "NOMBRE":"13,0 Hospitalidade",
     "SUBSECTORES":{
        "3":"13.1 Hospitalidade // Serviço de alimentos e bebidas",
        "2":"13.2 Hospitalidade // Hotel / Resort",
        "1":"13.3 Hospitalidade // Administração",
        "4":"13.4 Hospitalidade // Outro"
     }
  },
  "8":{
     "NOMBRE":"16.0 Fabricação e produção",
     "SUBSECTORES":{
        "28":"16.1 Fabricação e Produção // Energia Alternativa",
        "1":"16.2 Fabricação e Produção // Automotiva",
        "15":"16.3 Fabricação e Produção // Metais Básicos e Produtos de Metal",
        "14":"16.4 Fabricação e produção // Materiais de construção",
        "24":"16.5 Fabricação e Produção // Produtos Químicos",
        "3":"16.6 Fabricação e Produção // Coque, derivados de petróleo e combustível nuclear",
        "8":"16.7 Fabricação e Produção // Equipamentos elétricos, eletrônicos e ópticos",
        "6":"16.8 Fabricação e Produção // Eletrônica",
        "7":"16.9 Fabricação e Produção // Energia",
        "5":"16.10 Fabricação e Produção // Distribuição de Energia",
        "20":"16.11 Fabricação e Produção // Produtos Alimentares: Produtos lácteos e avícolas",
        "21":"16.12 Fabricação e Produção // Produtos Alimentares: Tabaco",
        "19":"16.13 Fabricação e Produção // Produtos Alimentares: Bebidas",
        "18":"16.14 Fabricação e Produção // Produtos Alimentares: Outros",
        "16":"16.15 Fabricação e Produção // Móveis",
        "10":"16.16 Fabricação e Produção // Gasolina / Varejo",
        "31":"16.17 Fabricação e produção // Cuidados de saúde",
        "17":"16.18 Fabricação e Produção // Couro e produtos de couro",
        "13":"16.19 Fabricação e Produção // Máquinas e equipamentos",
        "11":"16.20 Fabricação e Produção // Dispositivos Médicos",
        "22":"16.21 Fabricação e Produção // Minerais não metálicos",
        "2":"16.22 Fabricação e produção // Produtos para cuidados pessoais e domésticos",
        "23":"16.23 Manufatura e Produção // Celulose, papel e derivados de papel",
        "4":"16.24 Fabricação e Produção // Borracha e produtos plásticos",
        "25":"16,25 Fabricação e Produção // Segurança",
        "26":"16.26 Fabricação e Produção // Têxteis e produtos têxteis",
        "30":"16.27 Fabricação e Produção // Equipamento de transporte",
        "29":"16.28 Fabricação e Produção // Abastecimento e tratamento de água",
        "12":"16.29 Fabricação e Produção // Madeira e seus derivados",
        "32":"16.30 Fabricação e Produção // Outro",
        "27":"(OLD) Manufatura e Produção // Bens de consumo em rápida movimentação",
        "9":"(OLD) Manufatura e Produção // Saúde",
     }
  },
  "9":{
     "NOMBRE":"17.0 Media",
     "SUBSECTORES":{
        "1":"17.1 Mídia // Editores e impressoras",
        "4":"17.2 Mídia // Televisão / Filme / Vídeo",
        "2":"17.3 Mídia // Rádio",
        "3":"17.4 Mídia // Serviços de Internet",
        "5":"17.5 Mídia // Outro",
     }
  },
  "10":{
     "NOMBRE":"18.0 Mineração e pedreiras",
     "SUBSECTORES":{
        "1":"18.1 Minas e Pedreiras // Outro / Não se aplica"
     }
  },
  "11":{
     "NOMBRE":"(ANTIGO) Organizações sem fins lucrativos e de caridade",
     "SUBSECTORES":{
        "1":"-"
     }
  },
  "12":{
     "NOMBRE":"21.0 Comércio varejista",
     "SUBSECTORES":{
        "4":"21.1 Comércio varejista // Vestuário / Têxtil / Calçados",
        "2":"21.2 Comércio varejista // Computadores / eletrônicos",
        "1":"21.3 Comércio varejista // Alimentos / Armazém",
        "5":"21.4 Comércio varejista // Comércio eletrônico",
        "3":"21.5 Comércio Varejista // Produtos Especiais",
        "6":"21.6 Comércio varejista // Outro",
     }
  },
  "13":{
     "NOMBRE":"11.0 Serviços Financeiros e Seguros",
     "SUBSECTORES":{
        "1":"11.1 Serviços Financeiros e Seguros // Investimentos",
        "9":"11.2 Serviços Financeiros e Seguros // Contabilidade",
        "8":"11.3 Serviços Financeiros e de Seguros // Bancos / Serviços de Crédito",
        "5":"11.4 Serviços Financeiros e Seguros // Seguro Saúde",
        "7":"11.5 Serviços Financeiros e Seguros // Seguros em Geral",
        "6":"11.6 Serviços Financeiros e Seguros // Seguro de Vida",
        "3":"11.7 Serviços Financeiros e Seguros // Seguro Automóvel",
        "4":"11.8 Serviços Financeiros e Seguros // Seguro Residencial",
        "2":"11.9 Serviços Financeiros e Seguros // Resseguro",
        "10":"11.10 Serviços Financeiros e Seguros // Outro",
     }
  },
  "14":{
    "NOMBRE":"14.0 Serviços Industriais",
    "SUBSECTORES":{
      "3":"14.1 Serviços Industriais // Reparação e Manutenção de Veículos",
      "2":"14.2 Serviços Industriais // Desenho Industrial",
      "1":"14.3 Serviços Industriais // Gerenciamento de Resíduos / Lixo / Reciclagem",
      "4":"14.4 Serviços Industriais // Outros",
    }
  },
  "15":{
     "NOMBRE":"19.0 Serviços Profissionais",
     "SUBSECTORES":{
        "14":"19.1 Serviços Profissionais // Publicidade e Marketing",
        "2":"19.2 Serviços Profissionais // Arquitetura / Design",
        "5":"19.3 Serviços Profissionais // Consultoria - Administração",
        "7":"19.4 Serviços Profissionais // Consultoria de Engenharia",
        "4":"19.5 Serviços Profissionais // Consultoria Ambiental",
        "8":"19.6 Serviços Profissionais // Consultoria de Manufatura",
        "3":"19.7 Serviços Profissionais // Avaliação de Risco / Consultoria Atuarial",
        "11":"19.8 Serviços Profissionais // Assessoria Jurídica",
        "16":"19.9 Serviços Profissionais // Segurança",
        "15":"19.10 Serviços Profissionais // Contratação de Pessoal",
        "6":"19.11 Serviços Profissionais // Suporte por Telefone / Centros de Vendas",
        "1":"19.12 Serviços Profissionais // Administração de Viagens",
        "19":"19.13 Serviços Profissionais // Outro",
        "12":"(OLD) Serviços profissionais // Terceirização de processos de negócios",
        "13":"(OLD) Serviços profissionais // Terceirização de processos de negócios / Call centers",
        "9":"(OLD) Serviços Profissionais // Contabilidade, Escrituração e Auditoria",
        "17":"(OLD) Serviços profissionais // Publicidade e marketing / Publicidade",
        "18":"(OLD) Serviços Profissionais // Publicidade e Marketing / Marketing Direto",
        "10":"(OLD) Serviços profissionais // Educação e treinamento"
     }
  },
  "16":{
     "NOMBRE":"22.0 Serviços Sociais e Agências Governamentais",
     "SUBSECTORES":{
        "3":"22.1 Serviços Sociais e Agências Governamentais // Serviços Comerciais",
        "1":"22.2 Serviços Sociais e Agências Governamentais // Cultura e Arte",
        "2":"22.3 Serviços Sociais e Agências Governamentais // Educação",
        "6":"22.4 Serviços Sociais e Agências Governamentais ... Atividades gerais da administração pública",
        "5":"22.5 Serviços Sociais e Agências Governamentais // Habitação",
        "4":"22.6 Serviços Sociais e Agências Governamentais // Saúde Humana e Serviço Social",
        "7":"22.7 Serviços Sociais e Agências Governamentais // Assistência Residencial",
        "8":"22.8 Serviços Sociais e Agências Governamentais // Outros",
     }
  },
  "17":{
     "NOMBRE":"15.0 Tecnologias de Informação",
     "SUBSECTORES":{
        "3":"15.1 Tecnologia da Informação // Hardware",
        "4":"15.2 Tecnologia da Informação // Provedor de Serviços de Internet",
        "5":"15.3 Tecnologia da Informação // Software",
        "6":"15.4 Tecnologias de Informação // Serviços de Internet",
        "1":"15.5 Tecnologia da Informação // Consultoria de TI",
        "2":"15.6 Tecnologia da Informação // Armazenamento / Gerenciamento de Dados",
        "7":"15.7 Tecnologia da Informação // Outro",
     }
  },
  "18":{
     "NOMBRE":"24,0 Transporte",
     "SUBSECTORES":{
        "2":"24.1 Transporte // Companhia Aérea / Aviação Comercial",
        "1":"24.2 Transporte // Transporte de encomendas",
        "3":"24.3 Transporte // Transporte terrestre e marítimo de passageiros",
        "4":"24.4 Transporte // Transporte e Armazenamento",
        "5":"24.5 Transporte // Outro",
     }
  },
  "19":{
     "NOMBRE":"23,0 Telecomunicações",
     "SUBSECTORES":{
        "1":"23.1 Telecomunicações // Outro / Não se aplica"
     }
  },
  "20":{
     "NOMBRE":"8.0 Eletrônicos",
     "SUBSECTORES":{
        "1":"8.1 Eletrônicos // Outros / Não se aplica"
     }
  },
  "21":{
     "NOMBRE":"9.0 Engenharia",
     "SUBSECTORES":{
        "1":"9.1 Engenharia // Outro / Não se aplica"
     }
  },
  "22":{
     "NOMBRE":"10.0 Entretenimento",
     "SUBSECTORES":{
        "3":"10.1 Entretenimento // Artes cênicas e esportes para espectadores",
        "2":"10.2 Entretenimento // Museus",
        "1":"10.3 Entretenimento // Diversão e jogos de azar",
        "4":"10.4 Entretenimento // Outro",
     }
  },
  "23":{
     "NOMBRE":"20,0 Imóveis",
     "SUBSECTORES":{
        "1":"20.1 Imóveis // Habitação",
        "2":"20.2 Imóveis // Gestão de propriedades",
        "3":"20.3 Imóveis // Outros",
     }
  },
  "24":{
     "NOMBRE":"25,0 Outros",
     "SUBSECTORES":{
        "1":"25.1 Outro / Não se aplica"
     }
  },
  "25": {
    "NOMBRE":"3.0 Serviços para Idosos",
    "SUBSECTORES": {
      "1":"3.1 Serviços para Idosos // Alojamento e cuidados para Idosos",
      "2":"3.2 Serviços para Idosos // Assistência domiciliar",
      "3":"3.3 Serviços para Idosos // Outro",
    }
  }
}

export const ranking = {
  '1': {
    'NOMBRE': 'Sim',
    'TIPO': {
      '1': 'Menos de 50',
      '2': '50 a 500 Não-multinacionais',
      '3': '50 a 500 Multinacionais',
      '4': 'Grande (500 a 4999)',
      '5': '5000 ou mais'
      // '6': 'Sector público',
      // '7': 'No participa en la clasificación'
    }
  },
  '2': {
    'NOMBRE': 'Não',
    'TIPO': {
      '1': 'Menos de 50',
      '2': '50 a 500 Não-multinacionais',
      '3': '50 a 500 Multinacionais',
      '4': 'Grande (500 a 4999)',
      '5': '5000 ou mais'
    }
  },
  'Nacional': 'Nacional',
  'Multinacional': 'Multinacional'
}

export const productos = {
  '1': 'Certificar',
  '2': 'Medição',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentador NOM-035',
  '6': 'Focus Area',
  '7': 'Gestor de ficheiros',
  '8': 'Culture Audit',
  '9': 'Culture Audit 5.0',
  '10': 'Formação em Culture Audit',
  '11': 'Melhoria da medição',
  '12': 'Medição + MST',
  '13': 'Medição por áreas',
  '14': 'Medição por líderes',
  '15': 'Medição por dimensões',
  '16': 'Medição para certificar',
  '17': 'Resultados',
  '18': '4All',
  '19': 'NOM-035 Melhor',
  '20': 'Certificar v2.0',
  '21': 'Resultados globais',
  '22': 'Resultados simples e práticos 4ALL',
  '23': 'Resultados completos',
  '24': 'Pacote SILVER',
  '25': 'Pacote OURO',
  '26': 'Pacote PLATINA',
  '27': 'Izzi',
  '37': 'Auditoria de Cultura SP',
  '38': 'Plano de Ação ',
  '40': 'Certificar v3.0',
  '41': 'Medição v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Área de Foco v3.0',
  'CULTUREGOEXPRESS':'Cultural Go Express',
  '53':'Líder GO',
  '54':'Action GO',
  '56': 'AMCO',
  '57': 'Trabalho Decente',
  '58': 'Primeiro Emprego',
  'ENCUESTA':'Certificações adicionais',
  '60':'Certificado (importação emprising)',
  '61':'Culture Brief',
  '62':'Culture Audit',
  '63': 'NOM-035 v3.0',
  '64':'SP 2022',
  '65':'Culture Audit GoFlow 2 2022',
  '66':'Norma de Auditoria de Cultura 1',
  '69': 'Certificar prata',
  '70':'GoFlow resultados',
  '71':'Auditoria cultural (certificar) 2022',
  '72': 'Auditoria cultural (certificar, rkg.) 2022',
  '73': 'Auditoria cultural (certificar, rkg. e adic.) 2022',
  '68':'Swift',
  '76':'Auditoria cultural (certificar,rkg. y adic.) 2024',
  '77': 'Culture Brief (certifique) 2024',
  '78':'Auditoria de Cultura (certificar e classificar) 2024',
}
export const productosTurquia = {

  '1': 'Certificar',
  '2': 'Medição',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentador NOM-035',
  '6': 'Focus Area',
  '7': 'Gestor de ficheiros',
  '8': 'Culture Audit',
  '9': 'Resumo de cultura e auditoria de cultura 5.0',
  '10': 'Formação em Culture Audit',
  '11': 'Melhoria da medição',
  '12': 'Medição + MST',
  '13': 'Medição por áreas',
  '14': 'Medição por líderes',
  '15': 'Medição por dimensões',
  '16': 'Medição para certificar',
  '17': 'Resultados',
  '18': '4All',
  '19': 'NOM-035 Melhor',
  '20': 'Certificar v2.0',
  '21': 'Resultados globais',
  '22': 'Resultados simples e práticos 4ALL',
  '23': 'Resultados completos',
  '24': 'Pacote SILVER',
  '25': 'Pacote OURO',
  '26': 'Pacote PLATINA',
  '27': 'Izzi',
  '28': 'Culture Brief 5.0',
  '29': 'Auditoria de Cultura 5.0',
  '34': 'Resultados 5.0 Versão 3.1',
  '35': 'Resultados 5.0 Versão 3.2',
  '36': 'Resultados 5.0 Versão 3.3',
  '40': 'Certificar v3.0',
  '41': 'Medição v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Área de Foco v3.0',
  '60':'Certificado (importação emprising)',
  '54':'Action GO',
  '74':'Özel Liste',
}

export const categorias = {
  'Certify': 'Produtos Certificar',
  'Measure': 'Produtos de medição',
  'Norm 35': 'Produtos NOM-035',
  'Pulse Check': 'Produtos Pulse Check',
  'Focus Area': 'Produtos Focus Area',
  'Drive': 'Gestor de ficheiros',
  'Culture Audit': 'Produtos Culture Audit',
  'Resultados': 'Produtos de resultados',
  'Resultados 4 ALL': 'Produtos 4All',
  'Resultados 5.0': 'Resultados 5.0 produtos',
  'Culture Audit Action Plan':'Plano de ação',
  'Leader GO':'Líder GO',
  'Action GO':'Action GO',
  'Certify Amco':'Certificados adicionais',
  'PRODUCTOS_ICCA':'ICCA products',
  'Resultados V2 HK': 'Certificar (emprestar importação)',
  'Swift':'Swift',

}

export const niveles = {
  '1': 'Empresa',
  '2': 'Administrador',
  '3': 'ITBM',
  '4': 'Resultados',
  '5': 'Resultados segmentados',
  '8': 'Produto de Culture Audit',
  '9':'Resultados 5.0',
  '10':'RH da Empresa',
  '11': 'Izzi',
  '12': 'ActionGo',
  '13': 'Resultados segmentados e ActionGo',
  '14': 'ActionGo Leader',
  '15': 'Líder ActionGo do Utilizador',
  '17': 'Swift Wholesaler',
  '18': 'Perfil da empresa Web',
  '19': 'Resultados 2.0',
}

export const regiones = {
  '1': 'Caraíbas',
  '2': 'América Central',
  '3': 'América Central e Caraíbas',
  '4': 'Região Bajio',
  '5': 'Região Centro',
  '6': 'Região Centro-Oeste',
  '7': 'Região Centro Sul',
  '8': 'Região Nordeste',
  '9': 'Região Noroeste',
  '10': 'Região Sudeste',
  '11': 'Grande China',
  '12': 'Taiwan',
  '13': 'China continental',
  '14': 'Grande China',
  '15': 'Turquia',
}

export const plantillas = {
  '5d826095d06d596a84de6315': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5dcb61e940fb582bc44adf49': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5dcc946633e1ff000870107e': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5dcdd9fd33e1ff1aacf6f04f': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5ddc3fa4f323d727d09870ad': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5de58de640fb582e0c18d730': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5de69aa4a943da3efc4d0fa6': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
  },

  '5de9498fa943da3efc4d0fa8': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5df820df65e4986b14d1f71c': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  '5dfc26cec8800d5188a18875': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e166105d06d595eb04dca00': {
    'NOMBRE':'Focus_Estandar'
  },

  '5e1754a5f323d72aac6d8726': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e17930b65e4983a3016a4ed': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e2100c6f323d721045812c5': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e21042ff323d721045812c6': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e210575f323d721045812c7': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e2b6dbdc8800d52f45fc248': {
    'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
  },

  '5e2f72c8c8800d3398c463a4': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e3c59b5b473cb6d3e40f902': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e697232b473cb6d3e84d87d': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5ec8450db473cb6d3ec9d153': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_US_MEDIR1'
  },

  '5ec84527b473cb6d3ec9dcdb': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_MX_MEDIR1'
  },

  '5e6972f3b473cb6d3e84e1e0': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
  },

  '5e697302b473cb6d3e84e2a3': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
  },

  '5e697311b473cb6d3e84e364': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
  },

  '5e697329b473cb6d3e84e490': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
  },

  '5e69734fb473cb6d3e84e656': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
  },

  '5e697367b473cb6d3e84e791': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
  },

  '5e738efbb473cb6d3e8c3915': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5e86487eb473cb6d3e09cc42': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5e864896b473cb6d3e09cde1': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },
  '5ebb34dab473cb6d3edd2d32': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_US'
  },

  '5ebc06d1b473cb6d3ef68147': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MX'
  },

//PLANTILLAS DE CERTIFICAR 2.0
  '5e960018b473cb6d3ec5f935': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5e96007cb473cb6d3ec60098': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5e9600a6b473cb6d3ec603c7': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5e9600f0b473cb6d3ec6095a': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5e960116b473cb6d3ec60c2f': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5e96039fb473cb6d3ec64310': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e9603d7b473cb6d3ec6485e': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e9604f7b473cb6d3ec66540': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e960525b473cb6d3ec66a3f': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e960549b473cb6d3ec66e30': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e96056ab473cb6d3ec671f1': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e9605b5b473cb6d3ec67a55': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e9605e0b473cb6d3ec67f3c': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e96060fb473cb6d3ec684d8': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },
  '5f84a2fab473cb6d3e017c0d': {
    'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
  },
  '5f733fcab473cb6d3e19d56c': {
    'NOMBRE':'04_ESP_Gobierno_MX'
  },
  // pendiente TK
  '5e14fc2cf323d72aac6d8722': {
    'NOMBRE':' '
  },
  // pendiente TK
  '5e14fcc4f323d72aac6d8723': {
    'NOMBRE':' '
  },
  // pendiente MX
  '5d71b21db11f333a30de813e': {
    'NOMBRE':' '
  },
  '5fcebf59c1057065a70fe712':{
    'NOMBRE':'TR_ESTANDAR_+COVID v2'
  },
  '6046a10e7308ab51607f95b5':{
    'NOMBRE':''
  }
}

export const answer = {
  '1': 'Cultural Go Survey',
  '2': 'Kiosko',
  '3': 'No answer / Foreign leader',
  '4': 'Paper',
  '5': 'Does not apply',
}
